import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import GeneralTr from "../table-componets/GeneralTr.js";
import AttachmentsTr from "../table-componets/AttachmentsTr.js";
import SubmittedByTr from "../table-componets/SubmittedByTr.js";
import DateTr from "../table-componets/DateTr.js";
import AssignedTo from "./AssignedTo";

class Issue extends React.Component {
  state = {
    isOpen: this.props.issue.is_open,
    closedAt: this.props.issue.closed_at
  };

  deleteIssue = () => {
    axios
      .delete("/issues/" + this.props.issue.id)
      .then(function(response) {
        toastr.error("Issue deleted");
        setTimeout(
          function() {
            window.location.href = "/issues";
          }.bind(this),
          300
        );
      })
      .catch(function(error) {
        toastr.error("An error occured, please try again.");
        console.log(error);
      });
  };

  toggleStatus = status => {
    var that = this;

    if (status) {
      this.setState({ closedAt: null });
    } else {
      this.setState({ closedAt: moment() });
    }

    axios
      .put("/issues/" + this.props.issue.id + ".json", {
        issue: {
          is_open: status
        }
      })
      .then(function(response) {
        toastr.info("Issue status updated");
        that.setState({ isOpen: status });
      })
      .catch(function(error) {
        toastr.error("An error occured, please try again.");
        console.log(error);
      });
  };

  renderStatusButton = () => {
    var that = this;

    if (this.props.currentUser.admin && this.state.isOpen) {
      return (
        <span>
          <button
            className="btn btn-indigo btn-raised btn-long margin-right-five hidden-xs"
            onClick={function() {
              that.toggleStatus(false);
            }}
          >
            CLOSE
          </button>
          <button
            className="btn btn-indigo btn-raised btn-long visible-xs pull-right"
            onClick={function() {
              that.toggleStatus(false);
            }}
          >
            CLOSE
          </button>
          <br className="visible-xs" />
          <br className="visible-xs" />
        </span>
      );
    } else if (this.props.currentUser.admin && !this.state.isOpen) {
      return (
        <span>
          <button
            className="btn btn-indigo btn-raised btn-long margin-right-five hidden-xs"
            onClick={function() {
              that.toggleStatus(true);
            }}
          >
            RE-OPEN
          </button>
          <button
            className="btn btn-indigo btn-raised btn-long margin-right-five visible-xs pull-right"
            onClick={function() {
              that.toggleStatus(true);
            }}
          >
            RE-OPEN
          </button>
        </span>
      );
    }
  };

  render() {
    var that = this;

    return (
      <div>
        <h1>Issue</h1>
        {this.renderStatusButton()}
        <div className="pull-right">
          {(that.props.currentUser.admin ||
            that.props.currentUser.id == that.props.user.id) && (
            <a
              href={"/issues/" + that.props.issue.id + "/edit"}
              className="btn btn-pink btn-raised btn-long margin-right-five"
            >
              EDIT
            </a>
          )}

          <a
            href={"/issues/" + that.props.issue.id + ".pdf"}
            target="_blank"
            className="btn btn-indigo btn-raised btn-long margin-right-five hidden-xs"
          >
            PDF
          </a>

          {that.props.currentUser.admin && (
            <button
              className="btn btn-default btn-raised btn-long"
              onClick={function() {
                that.deleteIssue();
              }}
            >
              DELETE
            </button>
          )}
        </div>
        {(that.props.currentUser.admin ||
          that.props.currentUser.id == that.props.user.id) && (
          <span>
            <br />
            <br />
          </span>
        )}
        <br />
        <div className="shadowDepth1">
          <table className="table table-bordered table-white">
            <tbody>
              <GeneralTr
                fieldName={"Location"}
                fieldValue={that.props.location.name}
              />
              <GeneralTr
                fieldName={"Problem"}
                fieldValue={that.props.issue.problem}
              />
              <GeneralTr
                fieldName={"Description"}
                fieldValue={that.props.issue.description}
              />
              <GeneralTr
                fieldName={"Urgency"}
                fieldValue={that.props.issue.urgency}
              />
              <DateTr
                fieldName={"Due Date"}
                fieldValue={that.props.issue.due_date}
                fieldFormat={"M/D/YYYY"}
              />

              <GeneralTr
                fieldName={"Status"}
                fieldValue={that.state.isOpen ? "Open" : "Closed"}
              />

              {that.state.isOpen == false && (
                <DateTr
                  fieldName={"Closed At"}
                  fieldValue={that.state.closedAt}
                  fieldFormat={"M/D/YYYY @ h:mma"}
                />
              )}

              <AttachmentsTr
                fieldName={"Attachments"}
                fieldValue={that.props.attachments}
              />

              <SubmittedByTr user={that.props.user} />

              <DateTr
                fieldName={"Submitted At"}
                fieldValue={that.props.issue.created_at}
                fieldFormat={"M/D/YYYY @ h:mma"}
              />

              {that.props.assignedUsers.length > 0 && (
                <AssignedTo users={that.props.assignedUsers} />
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

Issue.propTypes = {
  issue: PropTypes.object,
  attachments: PropTypes.array,
  location: PropTypes.object,
  user: PropTypes.object,
  currentUser: PropTypes.object,
  assignedUsers: PropTypes.array
};

export default Issue;
